<template>
  <v-text-field
    :color="color"
    loading
    disabled
    class="px-1 py-0 my-0"
    :hide-details="hideDetails"
  />
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
